import { SerializableObject } from '../../common-react/core';

import { Locale } from '../other/locale.enum';

export class ShipmentServiceBracketLabel extends SerializableObject {
  public locale: Locale;
  public title: string;
  public description: string;
  public detailsHeader: string;
  public detailsPoints: string[];
}
